module.exports = __webpack_public_path__ + "img/imagen-compartir.e53cfd60.png";